import ServiceBase from './serviceBase';
import { LibraryBaseService, LibraryComment } from './types/LibraryBase';
import {
  MissionFilter,
  MissionList,
  MissionContainer,
  Mission,
  CreateMission,
} from './types/Missions';

class MissionService extends ServiceBase implements LibraryBaseService {
  exportExcel = async (filter: MissionFilter): Promise<boolean> => {
    await this.download('missions/excel', filter);
    return true;
  };

  getMissions = async (filter: MissionFilter): Promise<MissionList> =>
    this.post<MissionList>('missions/search', filter);

  getMission = async (id: string): Promise<MissionContainer> =>
    this.get<MissionContainer>(`missions/${id}/context`);

  saveDocuments = async (id: number, formData: FormData): Promise<number> =>
    this.post<number>(`missions/${id}/documents`, formData);

  saveDocumentComment = async (comment: LibraryComment): Promise<void> => {
    await this.post<void>(`missions/${comment.modelId}/document_comment`, comment);
  };

  downloadAttachment = async (missionId: number, docId: number): Promise<boolean> => {
    await this.download(`missions/${missionId}/attachment/${docId}`);
    return true;
  };

  create = async (mission: CreateMission): Promise<Mission> =>
    this.post<Mission>(`missions`, mission);

  update = async (mission: CreateMission): Promise<Mission> =>
    this.put<Mission>(`missions`, mission);

  cancel = async (missionId: number): Promise<boolean> =>
    this.post<boolean>(`missions/${missionId}/cancel`, missionId);

  getNextNumber = async (): Promise<string> => this.get<string>('missions/next-number');
}

const service = new MissionService();

export default service;
